import { InvoiceStatus } from '~/store/apis/dtos/loan/loans.dto';

export interface Invoice {
  totalAmount: string;
  sentDate: string | null;
  paidDate: string;
  dueDate: string;
  id: number;
  amortization: string;
  monthlyFee: string;
  status: InvoiceStatus;
  downloadable: boolean;
  nextSEPADDMonth: Date | null;
  lateDays?: number;
  daysBeforeDueDate?: number;
  lateFee?: string;
  amortizationOpen?: string;
  monthlyFeeOpen?: string;
  paperInvoiceFee?: string;
  reactivationFee?: string;
  feeDiscount?: string;
  latePenaltyFee?: string;
  amoFreeMonthExecuted?: boolean;
}
export interface CurrentInvoiceResponse {
  invoices: Invoice[];
  hasOverdueInvoices?: boolean;
  hasAllUpcomingInvoices?: boolean;
}

export const validCurrentInvoiceStatuses: InvoiceStatus[] = [
  'NEW',
  'OVERDUE',
  'COLLECTION',
  'PENDING',
  'UPCOMING',
];
